import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { ThreeCircles } from 'react-loader-spinner';

import { SwipeTransition, SwitchTransitionWrapper } from 'components/molecules';
import { Button, ToggleSwitch } from 'components/atoms';
import { FileIcon, ManualIcon } from 'components/icons';
import useWindowSize from 'hooks/useWindowSize';
import ManualType from './ManualType';
import FileType from './FileType';

import { MessageResultType } from 'queries/types/MessageResultType';
import { MessageFileType, MessageFormType } from 'queries/types/MessageFormType';

import './MessageForm.scss';

type MessageFormProps = {
  manualFormData: MessageFormType;
  setManualFormData: Dispatch<SetStateAction<MessageFormType>>;
  fileFormData: MessageFileType;
  setFileFormData: Dispatch<SetStateAction<MessageFileType>>;
  setResultData: Dispatch<SetStateAction<MessageResultType | null>>;
  formTypeFile: boolean;
  setFormTypeFile: Dispatch<SetStateAction<boolean>>;
};

const MessageForm: FC<MessageFormProps> = ({
  setResultData,
  setManualFormData,
  manualFormData,
  fileFormData,
  setFileFormData,
  formTypeFile,
  setFormTypeFile,
}) => {
  const [formValidated, setFormValidated] = useState<boolean>(false);
  const [submitForm, setSubmitForm] = useState<boolean>(false);
  const [loadingState, setLoadingState] = useState<boolean>(false);

  // eslint-disable-next-line
  const [windowWidth, windowHeight] = useWindowSize();

  return (
    <div className="message-form">
      <ToggleSwitch
        className="message-form__switch"
        switcherState={formTypeFile}
        setSwitcherState={setFormTypeFile}
        disabled={loadingState}
        values={[
          <ManualIcon key={'manual-icon'} className={'message-form__manual-icon'} />,
          <FileIcon key={'file-icon'} />,
        ]}
      />
      <SwitchTransitionWrapper
        state={formTypeFile}
        elements={[
          <p key={'file'} className="message-form__head-text">
            Upload an Excel file
          </p>,
          <p key={'manual'} className="message-form__head-text">
            Fill data manually
          </p>,
        ]}
      />
      <SwipeTransition
        elements={[
          <FileType
            key={'message-form-file-type'}
            submitForm={submitForm}
            fileFormData={fileFormData}
            setFileFormData={setFileFormData}
            setFormValidated={setFormValidated}
            setSubmitForm={setSubmitForm}
            setLoadingState={setLoadingState}
            setResultData={setResultData}
          />,
          <ManualType
            key={'message-form-manual-type'}
            manualFormData={manualFormData}
            setManualFormData={setManualFormData}
            setFormValidated={setFormValidated}
            submitForm={submitForm}
            setSubmitForm={setSubmitForm}
            setLoadingState={setLoadingState}
            setResultData={setResultData}
          />,
        ]}
        state={formTypeFile}
        className={'message-form__swipe'}
      />
      <div
        className={'message-form__submit-box'}
        style={{ top: formTypeFile ? '288px' : windowWidth >= 1053 ? '725px' : '795px' }}
      >
        <SwitchTransitionWrapper
          state={formTypeFile}
          time={500}
          className={'message-form__swipe-box'}
          elements={[
            <Button
              onClick={() => {
                setSubmitForm(true);
                setLoadingState(true);
                setFormValidated(false);
              }}
              key="message-form-submit-btn"
              className={'message-form__submit'}
              disabled={!formValidated || loadingState}
              primary
            >
              {loadingState ? (
                <ThreeCircles
                  visible={true}
                  height="20"
                  width="20"
                  color="white"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              ) : (
                <>Submit</>
              )}
            </Button>,
            <Button
              onClick={() => {
                setSubmitForm(true);
                setLoadingState(true);
                setFormValidated(false);
              }}
              key="message-form-submit-btn-2"
              className={'message-form__submit'}
              disabled={!formValidated || loadingState}
              primary
            >
              {loadingState ? (
                <ThreeCircles
                  visible={true}
                  height="20"
                  width="20"
                  color="white"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              ) : (
                <>Submit</>
              )}
            </Button>,
          ]}
        />
      </div>
    </div>
  );
};

export default MessageForm;
